export const handleActiveMenu = (menu, tag) => {
	if (menu.key === tag) {
		console.log('handleActiveMenu', menu, tag);
		return 'ant-menu-item-selected';
	}
};
